<template>
  <div>
    <Nav :current="current"></Nav>
    <div class="content">
      <div class="title" v-show="btnType == 0">公司信息</div>
      <div class="title" v-show="btnType == 1">修改公司信息</div>
      <div class="form">
        <div class="form_item">
          <span class="item_name"><span class="xing">*</span> 公司名称</span>
          <input
            type="text"
            class="inputs"
            v-model="inputList.company"
            :disabled="disabled"
          />
          <span class="xing">* 为必填项</span>
        </div>
        <div class="form_item">
          <span class="item_name indent">地址</span>
          <input
            type="text"
            class="inputs"
            v-model="inputList.address"
            :disabled="disabled"
          />
        </div>
        <div class="form_item">
          <span class="item_name indent">税号</span>
          <input
            type="text"
            class="inputs"
            v-model="inputList.code"
            :disabled="disabled"
          />
        </div>
        <div class="form_item">
          <span class="item_name indent">备注</span>
          <input
            type="text"
            class="inputs"
            v-model="inputList.remark"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>

    <el-row class="el-row" v-show="btnType == 0">
      <el-button type="primary" class="el-button btnSty" @click="updateForm"
        >修改</el-button
      >
      
    </el-row>
    <el-row class="el-row" v-show="btnType == 1">
      <el-button
        type="primary"
        class="el-button btnSty"
        @click="preservationForm"
        >保存</el-button
      >
      <el-button class="el-button btnret" @click="preservationForm"
        >返回</el-button
      >
    </el-row>
  </div>
</template>
<script>
import http from "@/config/httpConfig";
import apiData from "@/config/api";
import Nav from "@/components/Nav.vue";
export default {
  name: "showSwitchboard",
  components: {
    Nav,
  },
  data() {
    return {
      current: '我的公司',
      btnType: 0,
      disabled: true,
      btnListL: [],
      company:'',
      inputList: [
        {
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.inputStyle();
    this.getCompany();
  },
  methods: {
    //获取公司信息
    getCompany() {
      let _this = this;
      http.get(apiData.showCompany, true, {}, function (res) {
        _this.inputList = res.data.data;
         _this.company = res.data.data.company
        console.log(_this.inputList);
      });
    },
    inputStyle() {
      var _this = this;
      // 给input
      _this.btnList = document.getElementsByClassName("inputs");
      for (let i = 0; i < _this.btnList.length; i++) {
        _this.btnList[i].style.background = "#CCCCCC";
      }
    },
    // 修改按钮事件
    updateForm() {
      var _this = this;
      _this.btnType = 1;
      _this.disabled = false;
      for (let i = 0; i < _this.btnList.length; i++) {
        _this.btnList[i].style.background = "";
      }
    },
    // 保存按钮事件
    preservationForm() {
      let _this = this;
      let params = _this.inputList;
      _this.btnType = 0;
      _this.disabled = true;

      if(_this.inputList.company === _this.company){
         http.put(apiData.updateCompany, true, params, function (res) {
        if (res.data.code == 200) {
          for (let i = 0; i < _this.btnList.length; i++) {
            _this.btnList[i].style.background = "#cccccc";
          }
        _this.getCompany()
        }
      });
      }else{
         http.put(apiData.updateCompany, true, params, function (res) {
        if (res.data.code == 200) {
          for (let i = 0; i < _this.btnList.length; i++) {
            _this.btnList[i].style.background = "#cccccc";
          }
          _this.$alert('公司名称修改成功,需要重新登录才能加载最新的公司信息。', '提示', {confirmButtonText: '确定',});
        _this.getCompany()
        }
      });
       
      }
     
      
      
    },
  },
};
</script>

<style scoped lang="less">
.content {
  text-align: left;
  .title {
    width: 100%;
    height: 56px;
    line-height: 56px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    text-indent: 10px;
  }

  .form {
    .form_item {
      display: flex;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-indent: 10px;

      input {
        width: 280px;
        height: 30px;
        margin-top: 5px;

        background: transparent;
        border: 1px solid rgb(204, 204, 204);
        text-indent: 10px;
      }

      .xing {
        color: #ffba1a;
      }

      .indent {
        padding-left: 10px;
      }
    }

    .item_name {
      width: 160px;
      display: block;
      color: #666;
    }

    .form_item:nth-child(odd) {
      background: #f8f8f8;
    }
  }
}

.el-row {
  text-align: center;
  height: 40px;
  width: 100%;
  margin: 200px 0;
}

.btnret:hover {
  background: #55c4b8;
  border: 1px solid #55c4b8;
  color: #f8f8f8;
}

.el-button {
  width: 200px;
  height: 40px;
  border: 1px solid #55c4b8;
  color: #55c4b8;
}

.btnSty {
  background: #55c4b8;
  color: #fff;
}
.btnSty:hover {
  background: #55c4b8;
  color: #fff;
  border: 1px solid #55c4b8;
}
</style>
